module.exports = __webpack_public_path__ + "static/media/navori-labs-2-cropped.5bb8c52d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/navori-labs-2-cropped.jpg
// module id = 55
// module chunks = 0